export default __webpack_public_path__ + "static/media/HH59789_tn.8a991b9a.jpg";